import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    mainContainer: {
        position: 'relative',
        overflow: 'hidden',
    },
    mapsContainer: {
        height: 'calc(100vh - 118px)',
        zIndex: 1,
        position: 'relative'
    },
    leftDrawerContainer: {
        top: '0px',
        left: '-25%',
        position: 'absolute',
        width: '25%',
        height: "100%",
        background: 'white',
        maxWidth: '450px',
        minWidth: '400px',
        boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
        zIndex: 10,
        transition: 'left 0.3s ease-out'
    },
    leftDrawerContainerButtonBox: {
        position: 'absolute',
        top: '10px',
        right: '-36px',
        width: '36px',
        height: '32px',
        backgroundColor: theme.palette.primary.main,
        borderRadius: '0 16px 16px 0',
        cursor: 'pointer'
    },
    leftDrawerContainerButtonIcon: {
        margin: '3px 0 3px 10px'
    },
    rightFilterContainer: {
        position: 'absolute',
        top: '20pt',
        right: '27px',
        zIndex: 10
    },
    titleLabel: {
        fontSize: "14px",
        fontWeight: 600
    },
    filterContainer: {
        backgroundColor: '#fff',
        padding: theme.spacing(1.5, 3),
        alignItems: 'center',
        width: 360,
        borderRadius: '10px 10px 0 0',
    },
    filterItems: {
        display: 'flex',

    },
    filterWrapper: {
        display: 'flex',
        justifyContent: "flex-end"
    },
    filterItemContainer: {
        display: "flex",
        alignItems: 'center',
        marginRight: "12px",
        backgroundColor: '#fff',
        borderRadius: 4,
        padding: '0 8px',
        boxShadow: ' rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px'
    },
    checkBox: {
        marginRight: 0
    },
    mapContainer: {
        height: '100vh',
        width: '70vh'
    },
    mapSidebarContainer: {
        position: 'relative',
        minWidth: '24vw',
        maxWidth: '24vw',
        zIndex: 999,
    },
    mapSidebar: {
        position: 'absolute',
        left: 0,
        top: 0
    },
    mapFilterWrapper: {
        position: 'relative',
        width: '100%',
        zIndex: 999,

    },
    mapFilterContanier: {
        position: 'absolute',
        top: 16,
        right: 0,
        display: 'flex',
        flexDirection: 'row'
    },
    mapFilterElement: {
        position: 'relative',
        width: '50vh',
        zIndex: 999
    },
    checkboxBox: {
        display: 'flex',
        justifyContent: "flex-end"
    },
    checkboxItem: {
        margin: theme.spacing(0, 0, 0, 1)
    },
    checkboxFormControl: {
        marginLeft: '0',
        '& .MuiFormControlLabel-label': {
            fontSize: '15px'
        }
    },
    driverLocatorPopup: {
        borderRadius: theme.typography.pxToRem(15),
        width: '360px',
        //marginTop: '80px',
        padding: theme.spacing(1.5, 3, 1.5, 3),
        position: 'absolute',
        top: 0,
        right: 0,
        marginTop: '90px',
        marginRight: '27px',
        zIndex: 1
    },
    driverLocatorLastKnownBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: "25px"
    },
    driverLocatorLastKnownBoxIconBox: {
        height: '20px'
    },
    driverLocatorLastKnownBoxIconImage: {
        width: '20px',
        height: '20px'
    },
    driverLocatorParkedIconImage: {
        width: '12px',
        height: '12px'
    },
    driverLocatorLastKnownBoxText: {
        fontSize: '14px',
        color: 'rgb(191,191,191)',
        padding: theme.spacing(0, 1),
        fontWeight: 500
    },
    driverLocatorPopupNameBox: {
        justifyContent: "center",
        display: "flex",
        padding: theme.spacing(3, 0, 5, 0),
    },
    driverLocatorPopupName: {
        fontSize: '18px',
        fontWeight: 700
    },
    driverLocatorPopupNameUnderline: {
        height: '2px',
        backgroundColor: theme.palette.primary.main
    },
    driverLocatorPopupRecentHourBox: {
        display: 'flex',
        justifyContent: 'space-between',
        marginTop: '10px',
        marginBottom: '25px',
    },
    driverLocatorPopupHourBox: {

    },
    imageIcon: {
        margin: "0 0.5em"
    },
    driverLocatorPopupRecentHourBoxTitle: {
        fontSize: '14px',
        fontWeight: 700,
        lineHeight: '1'
    },
    driverLocatorPopupRecentHourBoxSubTitle: {
        fontSize: '12px',
        color: 'rgb(177,177,177)'
    },
    driverLocatorPopupDivider: {
        margin: theme.spacing(1.8, 0),
        backgroundColor: 'rgb(216,216,216)'
    },
    driverLocatorPopupActionsBox: {
        padding: theme.spacing(1, 0)
    },
    driverLocatorPopupAction: {
        color: theme.palette.primary.main,
        fontWeight: 700
    },
    driverLocatorLastKnownDriveStateDate: {
        justifyContent: 'center',
        color: 'rgb(191,191,191)',
        display: 'flex',
        fontSize: '12px',
        marginTop: '2px'
    },
    driverLocatorDateTimeSepertor: {
        marginLeft: '5px',
        marginRight: '5px',
    },
    driverLocatorPopUpCloseButton: {
        position: 'absolute',
        right: '0',
        top: '0',
        zIndex: 1,
        cursor: 'pointer'
    },
    driverLocatorExpandButton: {
        position: 'absolute',
        right: '35px',
        top: '0',
        zIndex: 1,
        cursor: 'pointer'
    },
    driverLocatorPopupNameBoxShrink: {
        padding: theme.spacing(0, 0),
        display: 'flex',
        justifyContent: 'center',
    },
    cardWrapper: {
        borderRadius: theme.typography.pxToRem(15),
        // overflow: 'hidden',
        // maxWidth: theme.typography.pxToRem(330),
        // minWidth: theme.typography.pxToRem(300),
        // maxHeight: 'calc(100vh - 187px)',
        overflowY: 'auto'
    },
    resetToDefaultButton: {
        "&:hover": {
            backgroundColor: "#f9d13b",
        },
        height: '42px',
        backgroundColor: '#f9d13b'
    },
    myIconSizeMedium: {
        "& > *:first-child": {
            fontSize: '30px'
        }
    },
    refreshButton: {
        "&:hover": {
            backgroundColor: "white",
        },
        backgroundColor: 'white',
        zIndex: 10,
        color: '#A7A7A7',
        top: "15pt",
    },
    refreshButtonContainer: {
        textAlign: 'center'
    },

    mapDivIcon: {
        background: 'rgba(241, 211, 87, 0.6)',
        height: '40px',
        width: '40px',
        borderRadius: '20px',
        border: '0px',
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center'
    },

    mapClusterIconClass: {
        width: '30px',
        height: '30px',
        borderRadius: '15px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f9d13b'
    },

}));



